"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOriginHeader = void 0;
function serializeOrigin(origin) {
    var platform = origin.platform, application = origin.application, version = origin.version;
    return platform + "|" + application + "|" + version;
}
function createOriginHeader(origin) {
    return {
        "X-Fuze-Origin": serializeOrigin(origin)
    };
}
exports.createOriginHeader = createOriginHeader;
